import { AlarmClock, Atom, BookOpen, Bot, BriefcaseBusiness, Building2, Camera, Car, ChartNoAxesCombined, Clapperboard, Cloud, Code2, Coffee, Cpu, Drama, Earth, Flame, FlaskConical, Gamepad2, Globe, GraduationCap, HeartPulse, Landmark, Layers, Leaf, Lightbulb, List, Megaphone, Monitor, Music, Newspaper, Package, Palette, Plane, Podcast, RefreshCw, Rocket, ShieldCheck, ShoppingCart, Smartphone, Sparkles, Trophy, Users, Utensils, Wallet, Wrench, Zap } from 'lucide-react';

// Preserve stored emoji values for existing briefs and writer prompts; render SVGs.
export const briefIconChoices = [
  { value: '🔥', label: '주요 소식', icon: Flame },
  { value: '🤖', label: 'AI·IT', icon: Bot },
  { value: '🎬', label: '영상', icon: Clapperboard },
  { value: '🎨', label: '디자인·3D', icon: Layers },
  { value: '🌐', label: '경제·사회', icon: Globe },
  { value: '🎭', label: '엔터테인먼트', icon: Drama },
  { value: '💡', label: '레퍼런스', icon: Lightbulb },
  { value: '📰', label: '뉴스', icon: Newspaper },
  { value: '⏰', label: '시간·일정', icon: AlarmClock },
  { value: '🏢', label: '기업·부동산', icon: Building2 },
  { value: '📋', label: '목록·정리', icon: List },
  { value: '📊', label: '데이터·증시', icon: ChartNoAxesCombined },
  { value: '🔄', label: '업데이트', icon: RefreshCw },
  { value: '⚡', label: '에너지', icon: Zap },
  { value: '☕', label: '라이프스타일', icon: Coffee },
  { value: '🍽️', label: '음식', icon: Utensils },
  { value: '🚗', label: '자동차·모빌리티', icon: Car },
  { value: '📱', label: '모바일', icon: Smartphone },
  { value: '🛒', label: '쇼핑·커머스', icon: ShoppingCart },
  { value: '📦', label: '제품·물류', icon: Package },
  { value: '💻', label: '개발·코딩', icon: Code2 },
  { value: '🖥️', label: '디스플레이·하드웨어', icon: Monitor },
  { value: '🧠', label: '반도체·컴퓨팅', icon: Cpu },
  { value: '☁️', label: '클라우드', icon: Cloud },
  { value: '🛡️', label: '보안', icon: ShieldCheck },
  { value: '✨', label: '트렌드·추천', icon: Sparkles },
  { value: '🖌️', label: '아트·컬러', icon: Palette },
  { value: '📷', label: '사진·촬영', icon: Camera },
  { value: '🎮', label: '게임', icon: Gamepad2 },
  { value: '🎵', label: '음악', icon: Music },
  { value: '🎙️', label: '방송·팟캐스트', icon: Podcast },
  { value: '🏆', label: '스포츠·수상', icon: Trophy },
  { value: '📚', label: '책·콘텐츠', icon: BookOpen },
  { value: '🎓', label: '교육', icon: GraduationCap },
  { value: '🔬', label: '연구·과학', icon: FlaskConical },
  { value: '⚛️', label: '기초과학', icon: Atom },
  { value: '🚀', label: '우주·스타트업', icon: Rocket },
  { value: '🌱', label: '환경·지속가능성', icon: Leaf },
  { value: '🩺', label: '건강·의료', icon: HeartPulse },
  { value: '✈️', label: '여행·항공', icon: Plane },
  { value: '🌍', label: '국제·세계', icon: Earth },
  { value: '🏛️', label: '정책·공공', icon: Landmark },
  { value: '💰', label: '금융·투자', icon: Wallet },
  { value: '💼', label: '비즈니스·채용', icon: BriefcaseBusiness },
  { value: '👥', label: '사람·커뮤니티', icon: Users },
  { value: '📣', label: '마케팅·공지', icon: Megaphone },
  { value: '🔧', label: '도구·제작', icon: Wrench },
];
export function findBriefIcon(value: string) {
  const normalized = value?.replace(/\uFE0F/g, '');
  return briefIconChoices.find(item => item.value.replace(/\uFE0F/g, '') === normalized);
}
export default function BriefIcon({ value, className = 'h-5 w-5 shrink-0' }: { value: string; className?: string }) {
  // Legacy 📝 and unknown values retain the newspaper fallback.
  const Icon = findBriefIcon(value)?.icon || Newspaper;
  return <Icon className={className} aria-hidden="true" strokeWidth={1.75} />;
}
